import {getUseridFromUrl} from '@/common/util';
const generatePayOfflineContent = content => {
    let items = [];
    try {
        const res =  JSON.parse(content);
        items = res.items;
    }
    catch (err) {
    }
    let result = '恭喜您，您购买的';
    if (items.length > 0) {
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const {type, skuName, skuDesc, count} = item;
            if (type === 'times') {
                result += `${skuName}${skuDesc}次数x${count}`;
            }
            else {
                result += `${count}点券`;
            }
            if (i < items.length - 1) {
                result += '、';
            }
        }
    }
    else {
        result += '商品';
    }
    const {protocol, host} = window.location;
    const userid = getUseridFromUrl();
    const prefix = `${protocol}//${host}`;
    const href = `${prefix}/user/${userid}/userCenter/order`;
    result += `已到账，快去使用吧~前往<a href=${href} target="_blank">【我的订单】</a>查看详情>>`;
    return result;
};
export default class MessageModel {
    constructor({request}) {
        this.request = request;
    }

    async getMessageList(params) {
        const res = await this.request.fetch('natasha/POST/MessagesService/queryMessages', params);
        const {listData, totalCount} = res;
        const list = listData.map(item => {
            const {contentType, content} = item;
            // 线下购买到账消息
            if (contentType === 1) {
                return {
                    ...item,
                    jsonContent: content,
                    content: generatePayOfflineContent(content)
                };
            }
            else if (content[0] === '{' && content.substr(-1) === '}') {
                try {
                    let jsonContent = JSON.parse(content);
                    if (jsonContent.html) {
                        return {
                            ...item,
                            jsonContent,
                            content: jsonContent.html
                        };
                    }
                }
                catch (e) {
                    // do nothing
                }
            }
            return {
                ...item
            };
        });
        return {
            listData: list,
            totalCount
        };

    }
    async deleteMessages(params) {
        return this.request.fetch('natasha/POST/MessagesService/deleteMessages', params);
    }
    async changeMessagesStatus(params) {
        return this.request.fetch('natasha/POST/MessagesService/changeStatus', params);
    }

}
